'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dId$0024 from "./presto.types$-Envelope-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$34() {
  this.bhj = null;
  this.bhh = null;
  this.bhi = false;
  this.bhf = null;
  this.bhg = false;
  this.bhk = false;
  this.bhl = false;
  this.bhj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$34 as $c_Lpresto_PrestoRouter$$anon$34 };
$p = $c_Lpresto_PrestoRouter$$anon$34.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$34;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$34() {
}
export { $h_Lpresto_PrestoRouter$$anon$34 as $h_Lpresto_PrestoRouter$$anon$34 };
$h_Lpresto_PrestoRouter$$anon$34.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bhj;
});
$p.t = (function() {
  if ((!this.bhi)) {
    this.bhh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bhi = true;
  }
  return this.bhh;
});
$p.ae = (function() {
  if ((!this.bhg)) {
    this.bhf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEnvelope$002dId$0024.$m_Lpresto_types$EnvelopeId$().cI1(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bhg = true;
  }
  return this.bhf;
});
$p.w = (function() {
  if ((!this.bhl)) {
    this.bhk = false;
    this.bhl = true;
  }
  return this.bhk;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$34 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$34, "presto.PrestoRouter$$anon$34", ({
  NZ: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$34 as $d_Lpresto_PrestoRouter$$anon$34 };
//# sourceMappingURL=presto.-Presto-Router$$anon$34.js.map
